<script setup>
  import { ref, onBeforeMount } from "vue";
  import { useCompanyStore } from "@/stores/company";
import { useUiStore } from "@/stores/ui";
import { useCampaignsStore } from "@/stores/campaigns";

  const emit = defineEmits(['refresh']);
  const uiStore = useUiStore();
  const campaignsStore = useCampaignsStore();
  let id = ref(null);
  let name = ref(null);
  let isSubmitted = ref(false);
  const companyId = useCompanyStore().companyId;

  const onSubmit = () => {
    isSubmitted.value = true;
    campaignsStore.deleteCampaign({
      id : id.value,
      companyId : companyId
    })
    .then(() => {
      isSubmitted.value = false;
      resetStoreData();
      emit('refresh');
    })
    .catch(() => {
      isSubmitted.value = false;
    });
  };

  const resetStoreData = () => {
    uiStore.resetModalStore();
  };

  onBeforeMount(()=>{
    if(uiStore.modalAction == 'delete_campaign'){
      id.value = uiStore.modalData.id;
      name.value = uiStore.modalData.name;
    }
  });
</script>

<template>
  <DModal v-if="getModalAction === 'delete_campaign'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Delete Campaign </template>

    <template #body>
      <div class="delete-text">
        <span>Are you sure you want to <b>"Delete"</b> the campaign "{{ name }}" ?</span>
      </div>
    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button @click="resetStoreData" :disabled="isSubmitted" type="button" class="btn btn-secondary cancel-button">Cancel</button>
          <button :disabled="isSubmitted" @click="onSubmit" type="button" class="btn btn-danger add-button mr-30" >
            Delete <span v-if="isSubmitted" class="spinner-sm" role="status" aria-hidden="true"></span>
          </button>
        </div>
      </div>
    </template>
  </DModal>
</template>
  
